import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { ORContactDataForm } from '@bo-client/shared/models/orderRequestWizard.model';
import { startWith } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConnectionChangeRequestTypeConfig } from '@bo-client/shared/config.model';
import { Observable } from 'rxjs';
import { Observe } from '@bo-client/shared/observe.util';
import { FieldConfigEnum } from '@bo-client/shared/constants/enums';
import { ConnectionObjectFormV2 } from '@bo-client/shared/models/connectionObject';

@Component({
  selector: 'app-order-request-wizard-contact-data',
  templateUrl: './order-request-wizard-contact-data.component.html',
  styleUrls: ['./order-request-wizard-contact-data.component.scss']
})
export class OrderRequestWizardContactDataComponent implements OnInit {
  @Input('formGroup') contactDataForm: ORContactDataForm;
  @Input() connectionChangeConfig: ConnectionChangeRequestTypeConfig;
  @Observe('connectionChangeConfig') connectionChangeConfig$: Observable<ConnectionChangeRequestTypeConfig>;
  @Input() connectionObjectData: ConnectionObjectFormV2['value'];

  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.contactDataForm.controls.differingInvoiceAddress.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        startWith(this.contactDataForm.controls.differingInvoiceAddress.value)
      )
      .subscribe((isDifferingInvoiceContact: boolean) => {
        this.resetDifferingInvoiceContactForm(isDifferingInvoiceContact);
      });
  }

  // Todo: Mit Validatoren lösen -> Benötigt wahrscheinlich eine neue ContactFormComponent
  private resetDifferingInvoiceContactForm(isDifferingInvoiceContact: boolean) {
    if (!isDifferingInvoiceContact) {
      for (const control of Object.values(this.contactDataForm.controls.invoiceContact.controls)) {
        control.clearValidators();
        control.setValue(null);
      }
    }
  }

  protected readonly FieldConfigEnum = FieldConfigEnum;
}
